import { render, staticRenderFns } from "./HistoryBill.vue?vue&type=template&id=965f841e&scoped=true&"
import script from "./HistoryBill.vue?vue&type=script&lang=js&"
export * from "./HistoryBill.vue?vue&type=script&lang=js&"
import style0 from "./HistoryBill.vue?vue&type=style&index=0&id=965f841e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "965f841e",
  null
  
)

export default component.exports